import { Box, Stack, Typography } from '@mui/material';

interface IEmptyStateCardProps {
  image: string;
  title: string;
  description: string;
}

export const EmptyStateCard: React.FC<IEmptyStateCardProps> = ({
  image,
  title,
  description,
}) => (
  <Stack
    alignItems="center"
    justifyContent="center"
    gap={1}
    bgcolor="background.backgroundPrimary"
    borderRadius="16px"
    pt={{ xs: 2, tablet: 0 }}
    pb={{ xs: 4, tablet: 7 }}
    px={2}
    my={{ xs: 3, tablet: 6 }}
    mx="auto"
    width="100%"
    maxWidth="39rem"
  >
    <Box
      component="img"
      src={image}
      alt=""
      width="100%"
      maxWidth="26rem"
      height="15rem"
      sx={{ objectFit: 'contain' }}
    />
    <Typography variant="h2" textAlign="center">
      {title}
    </Typography>
    <Typography
      variant="body1"
      color="text.secondary"
      textAlign="center"
      maxWidth="25rem"
    >
      {description}
    </Typography>
  </Stack>
);
